import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=21f63759&scoped=true&"
import script from "./FlagIcon.vue?vue&type=script&lang=js&"
export * from "./FlagIcon.vue?vue&type=script&lang=js&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=21f63759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f63759",
  null
  
)

export default component.exports